import { translate } from 'utils/translate';

const FREE_PALLETS_LABELS: Record<string, () => string> = {
   one: () => translate('labels.free_pallets_one'),
   few: () => translate('common.free'),
   many: () => translate('labels.free_pallets_many'),
};

export const getFreePalletsLabel = (palletAmount: number) => {
   const pluralRules = new Intl.PluralRules('pl-PL');
   const grammaticalNumber = pluralRules.select(palletAmount);
   return FREE_PALLETS_LABELS[grammaticalNumber]();
};
